import styled from 'styled-components'
import Icon from '@mdi/react'

import { CommonLink } from 'components/Button'
import { WhiteBlock } from 'components/Layout'

import theme from 'theme_'

export const BillHistoryContainer = styled.div`
  width: 100%;

  @media ${theme.devices.tablet} {
    overflow-x: auto;
  }
`

export const BillHistoryTableWrapper = styled.div`
  @media ${theme.devices.tablet} {
    width: 1200px;
    min-width: 100%;
  }
`

export const BillHistoryDateCell = styled.div<{ $failed?: boolean }>`
  ${(p) => p.$failed && 'opacity: 0.5'}
`

export const BillHistoryHomeNameCell = styled.div<{ $failed?: boolean }>`
  white-space: nowrap;

  ${(p) => p.$failed && 'opacity: 0.5'}
`

export const BillHistoryHomeNameLink = styled(CommonLink)`
  color: ${theme.colors.horizonOrange};
`

export const BillHistoryDescriptionCell = styled.div<{ $failed?: boolean }>`
  display: flex;
  align-items: center;

  ${(p) => p.$failed && 'opacity: 0.5'}
`

export const BillHistoryPaymentCell = styled.div<{ $failed?: boolean }>`
  display: flex;
  align-items: center;

  ${(p) => p.$failed && 'opacity: 0.5'}
`

export const BillHistoryAmountCell = styled.div<{ $failed?: boolean }>`
  font-weight: 700;

  ${(p) => p.$failed && 'opacity: 0.5'}
`

export const BillHistoryStatusCell = styled.div`
  position: relative;
  z-index: 1;
`

export const BillHistoryDownloadIcon = styled(Icon)`
  color: ${theme.colors.horizonOrange};

  &:hover {
    opacity: 0.8;
  }
`

export const BillHistoryErrorIcon = styled(Icon)`
  color: ${theme.colors.horizonOrange};
`

export const BillHistoryMobileWhiteBlock = styled(WhiteBlock)`
  width: 100%;
`

export const BillHistoryMobileRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${theme.spacing.xs} 0;
`
